export const Diapers: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.8759 20.3863V13.9774C21.8759 11.7409 20.0628 9.92773 17.8262 9.92773H4.17953C2.51844 9.92773 1.17188 11.2743 1.17188 12.9354V24.702C1.17188 26.6655 3.00781 28.1124 4.91703 27.6537L18.7725 24.324C20.5928 23.8865 21.8759 22.2584 21.8759 20.3863Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.712 54.5461V70.0331L25.6247 70.0673C24.0915 70.3225 8.89404 61.2609 3.75342 40.3506L21.4622 48.059C24.0436 49.1826 25.712 51.73 25.712 54.5461Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75342 33.2345V40.3503C8.89404 61.2606 24.0915 70.3222 25.6247 70.067C25.6623 70.0619 25.6915 70.0498 25.712 70.0328H54.2879C54.3084 70.05 54.3376 70.062 54.3753 70.067C55.9084 70.3222 71.1059 61.2606 76.2465 40.3503V27.7656"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.2471 9.92773H3.75244"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.124 20.3863V13.9774C58.124 11.7409 59.9371 9.92773 62.1737 9.92773H75.8203C77.4814 9.92773 78.8279 11.2743 78.8279 12.9354V24.702C78.8279 26.6655 76.992 28.1124 75.0828 27.6537L61.2273 24.324C59.4072 23.8865 58.124 22.2584 58.124 20.3863Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.2881 62.0675V70.0331L54.3754 70.0673C55.9086 70.3225 71.1061 61.2609 76.2467 40.3506L58.5379 48.059C55.9565 49.1828 54.2881 51.73 54.2881 54.5461V56.5618"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.4488 36.583C51.4488 34.2912 49.5911 32.4336 47.2994 32.4336C45.0077 32.4336 43.15 34.2914 43.15 36.583C43.15 36.7391 43.1594 36.8928 43.1763 37.0445C42.1935 36.7478 41.1225 36.583 40 36.583C38.8775 36.583 37.8066 36.7478 36.8238 37.0445C36.8406 36.893 36.85 36.7391 36.85 36.583C36.85 34.2912 34.9922 32.4336 32.7006 32.4336C30.4089 32.4336 28.5513 34.2914 28.5513 36.583C28.5513 38.6444 30.0547 40.3537 32.0247 40.6767C31.6311 41.4228 31.4124 42.2363 31.4124 43.0889C31.4124 46.682 35.2572 49.5947 40 49.5947C44.7428 49.5947 48.5877 46.682 48.5877 43.0889C48.5877 42.2364 48.3689 41.423 47.9753 40.6767C49.9453 40.3537 51.4488 38.6444 51.4488 36.583Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.8262 43.7139H40.9724"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.0522 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.8315 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.6104 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.3896 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.1685 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.9478 18.4014V23.0836"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
